<template>
    <div class="container">


        <!-- Items rows -->
        

        <div v-for="(item, index) in cartItems" :key="index" class="row item-row pt-4 pb-4">
            

            <!-- Mobile Version  d-md-none -->
            <div class="col-12" >
                <div class="row">
                    <div class="col-3" :class="{'grayed-out': !item.isAlreadyPersonalised}">
                        <a :href="'/sac-personnalise' + item.url"><img class="imageClass" v-bind:src="'/api/image/get/product/small/' + item.variants[0].images[0]" alt="" /></a>
                    </div>
                  
                        <div class="col-9">

                    
                            <div class="product-details ">

                                <div class="row">
                                    <div class="col-11 text-left" :class="{'grayed-out': !item.isAlreadyPersonalised}">
                                        <div class="product-name   "><a  style="line-height: 1.5;" :href="'/sac-personnalise' + item.url">{{ item.title }}</a></div>
                                        <small class="text-muted font-size-16" :class="{'grayed-out': !item.isAlreadyPersonalised}"> {{ item.variants[0].title }}</small>
                                        <div><span class="badge badge-light font-weight-bold">{{ item.paperTypeLabel }}</span></div>
                                        <div><span class="badge badge-light font-weight-bold">{{ item.paperColorLabel }}</span></div>
                                    </div>
                                    <div class="col-1 text-right"> 
                                        <img @click="openDeleteModal(item)" class="icontrash" alt="" src="@/assets/icons/trash.svg" style="cursor: pointer;" />
                                    </div>
                                </div>
                                                            

                                <div class="text-left subtotalClass mt-2 mb-1" :class="{'grayed-out': !item.isAlreadyPersonalised}">{{ item.variants[0].cartItemSubTotal }}</div>                             
                                
                                <div class="text-left quantity-text " :class="{'grayed-out': !item.isAlreadyPersonalised}"> Quantité : {{ item.variants[0].cartItemQuantity }} Sacs</div>
                                
                            </div>

                            <div class="text-right mt-2">
                                <a :href="'/personnalisation-produit/' + item.bagDesignCode">
                                    <b-button variant="outline-primary" class="text-uppercase" size="sm" > {{ !item.isAlreadyPersonalised ? 'Personnaliser' : 'Ouvrir' }}  </b-button>
                                </a>
                            </div>
                            <p v-if="showError && item.isAlreadyPersonalised == false && bagsDesignCode != null && item.bagDesignCode ==  bagsDesignCode" class="text-danger mb-0 pb-0 mt-1">Produit est en cours de persoonalisation.</p>

                        </div>
                </div>
            </div>


            <CartNotification v-if="item.cartItemDelayWarning"></CartNotification>

        </div>
        <b-modal
            v-model="showDeleteModal"
            :title="'Confirmer la suppression - ' +  itemToDelete.title +' de type ' + (itemToDelete.variants  ? itemToDelete.variants[0].title  : '') "
            hide-footer
            centered
            title-class="text-dark"
            title-tag="h5"
            size="lg"
            header-close-variant="secondary"
            >
            <div class="text-center">

                <p>Êtes-vous sûr de vouloir supprimer <strong> {{ itemToDelete.title }}</strong> <span>de type </span><strong>{{ itemToDelete.variants  ? itemToDelete.variants[0].title  : ''}}</strong> de votre panier ?</p>
                
                <b-button variant="danger" class="mr-2" @click="confirmDelete">
                    Supprimer
                </b-button>
                
                <b-button variant="secondary" @click="showDeleteModal = false">
                Annuler
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script >
import CartNotification from "./cartNotification.vue"

export default ({
    name: "ElementsCartCartItems",
    components: {
        CartNotification
    },

    props: {
        cart:{
            type: Object,
            default:null
        },
    },

    data() {
        return {
            isQuantityEditing: false,
            bagsDesignCode: null,
            showError: false,
            showDeleteModal: false,
            itemToDelete: {},
        };
    },

    watch: {

        '$route': {
            immediate: true,
            deep: true, 
            handler(route) {
                this.bagsDesignCode = route.params.code;
            }
        },
    },

    computed: {
        cartItems() {
            return  this.cart && this.cart.lines ? this.cart.lines.list : [];
        },

    },

    methods: {
    
        openDeleteModal(item) {
            if( item.isAlreadyPersonalised == false && this.bagsDesignCode != null && item.bagDesignCode ==  this.bagsDesignCode){
                this.showError = true 
                return ; 
            }else if(item.isAlreadyPersonalised == true){
                this.showError = false 
                this.itemToDelete = item;
                this.showDeleteModal = true;
            }else{
                this.remove(item);
                this.showError = false 
            }
           
        },
        confirmDelete() {
            this.remove(this.itemToDelete);
            this.showDeleteModal = false;
        },
        remove(item) {
            this.$store.dispatch('removeFromCart', item.variants[0].id);
        },
    },
})


</script>
            
<style scoped>

.grayed-out {
  opacity: 0.5;
  filter: grayscale(100%);
}

.container {
    align-items: center;

}

.header {
    display: flex;
    width: 100%;
    /*max-width: 960px;*/
    margin: 0 auto;
    border-bottom: 1px solid #cbcbcb;
    color:#121212;
}

.item-row {
    display: flex;
    width: 100%;
   /* max-width: 960px;*/
    margin: 0 auto;
    border-bottom: 1px solid #cbcbcb;
}

.titles {
    flex: 1;
    position: relative;
    height: 28px;
    font-size: 16px;
    letter-spacing: -0.4px;
    line-height: 28px;
    font-weight: 500;
   /* font-family: 'Space Grotesk';*/
}

.imageClass {
    width: 100%;
    max-width: 100px;
    height: auto;
}

.product-info {
    display: flex;
}

.product-details {
    margin-left: 16px;
}

.product-name {
    font-size: 18px;
    line-height: 22px;
    font-weight: 600;
    
    gap: 4px;

}

.product-size-color {
    font-size: 14px;
    line-height: 20px;
    
    color: #605f5f;
    text-align: left;
}

.button {
    display: flex;
    gap: 4px;
    cursor: pointer;
    align-items: center;
}

/* Mobile Version */
@media screen and (max-width: 767px) {
    .button {
        justify-content: flex-end;
    }
}

/* Web Version */
@media screen and (min-width: 768px) {
    .button {
        flex-direction: row;
        justify-content: flex-start;
    }
}


.icontrash {
    position: relative;
    width: 18px;
    height: 18px;
}

.delete {
    position: relative;
    font-size: 12px;
    line-height: 24px;
    font-weight: 500;
}

.quanity-container {
    display: flex;
    height: 100%;
}

/* Web Version */
@media (min-width: 576px) {
    .quanity-container {
        align-items: center;
    }
}

/* Mobile Version */
@media (max-width: 575.98px) {
    .quanity-container {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
    }
}

.content3 {
    position: absolute;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #cbcbcb;
    box-sizing: border-box;
    width: 80px;
    height: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 12px 8px;
    text-align: center;
    font-size: 12px;
    margin: auto;
}

.quantity-loading {
  position: relative;
  
}

.quantity-loading:before {
  content: '';
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 60%;
  width: 20px;
  height: 100%;
  margin-top: -10px;
  margin-left: -10px;
  border: 3px solid transparent;
  border-top: 3px solid #121212; 
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.iconminus {
    position: absolute;
    top: calc(50% - 8px);
    left: 5px;
    width: 16px;
    height: 16px;
    cursor: pointer;
}

.iconadd {
    position: absolute;
    top: calc(50% - 8px);
    right: 5px;
    width: 16px;
    height: 16px;
    cursor: pointer;
}

.quantity-text {
    line-height: 20px;
    font-weight: 600;
    color: #121212;
}

.priceClass {
    margin: auto;
    font-size: 18px;
    line-height: 30px;
    
    color: #121212;
}

.subtotalClass {
    margin: auto;
    font-weight: 600;
    
    color: #121212;
}

/* Web Version */
@media (min-width: 576px) {
    .subtotalClass {
        font-size: 18px;
        line-height: 30px;
    }
}

/* Mobile Version */
@media (max-width: 575.98px) {
    .subtotalClass {
        font-size: 14px; /* Adjust the font size for mobile */
        line-height: 24px; /* Adjust the line height for mobile */
    }
}
</style>